import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { HomeService } from '../../services/home.service';
import { UtilService } from '../../services/util.service';
import { PerfectScrollbarModule, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Router, RouterModule, Routes } from '@angular/router';

declare var jQuery:any
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  @ViewChild('closeBtn') closeBtn: ElementRef;
  innerHeight:any = 0;
  // public config: PerfectScrollbarConfigInterface = {};
  activeExerciseObj:any={description:'',id:null};
  userDetailsObj:any={image_90:''};
  routerUrl:string='';
  constructor(private authService:AuthService, private homeService: HomeService, private utilService:UtilService, private router:Router) { }

  ngOnInit() {
    this.userCurrentPath();
    this.openModal();
    this.userDetails();
    this.innerHeight = window.innerHeight-440;
    let url = this.router.url;
    if(url.indexOf('/settings') > -1) {
      this.routerUrl = 'settings'
    }else {
      this.routerUrl = url;
    }
  }

  userCurrentPath() {
    this.homeService.currentPath().subscribe(res=>{
      let active = false;
      if(res.status != undefined) {
        //For completed exercises.
        for(let index of res['exercises']) {
          if(index.status.status == 'active'){
            active = true;
            this.activeExerciseObj = index;
          }else if(index.status.status == 'completed') {
            //Add last completed exercise to active exercise if user completed all exercises.
            if(!active) {
              this.activeExerciseObj = index;
            }
          }
        }
      }
    });
  }

  ngOnDestroy() {
    this.closeBtn.nativeElement.click();
  }
  
  openModal() {
    jQuery('.modal').on('show.bs.modal', function () {
      jQuery("body").css({'position': 'fixed','overflow-y': 'hidden', 'width': '100%'});
    });
    jQuery('.modal').on('hidden.bs.modal', function () {
      jQuery("body").css({'position': '','overflow-y': 'inherit'});
    });
  }

  logOut() {
    this.closeBtn.nativeElement.click();
    setTimeout(() => {
      this.authService.logOut();
    }, 500);
  }

  userDetails() {
    this.utilService.userDetails().subscribe(res=>{
      this.userDetailsObj = res;
    });
  }

}



// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/menu/menu.component.ts